import { useEffect, useState } from 'react';
import { getBillingPolicy, getBillingPolicyByOps } from 'api/paymentSetup';
import { BillingPolicyType, IBillingPolicy } from 'types/paymentSetup';
import { isOpPortal } from 'api';
import HomeStore from 'store/Home';

export const initData: IBillingPolicy[] = [
    {
        type: BillingPolicyType.NO_SHOW,
        timeFrame: 15,
        fee: 25.0,
        enable: true,
    },
    {
        type: BillingPolicyType.LATE_CANCELLATION,
        timeFrame: 24,
        fee: 25.0,
        enable: true,
    },
];

export const useBillingPolicy = (isOps?: boolean, providerId?: number): [IBillingPolicy[], boolean, () => void] => {
    const [loading, setLoading] = useState(false);
    const [serviceData, setServiceData] = useState<IBillingPolicy[]>(initData);
    const [getHomeStore] = HomeStore.useStore();
    const isPPA = !!getHomeStore('data')?.ppaProvider;

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = isOps ? await getBillingPolicyByOps(providerId!) : await getBillingPolicy();
            if (!result.error) {
                const data: IBillingPolicy[] = result?.data?.data || [];
                setServiceData(isPPA && data.length === 0 ? initData : data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (!isOpPortal()) {
            fetchData();
        }
    }, []);

    return [serviceData, loading, fetchData];
};
